import { createSelector } from "reselect";
import { State } from "../../../redux/state";

export const paymentRoot = (state: State) => state.payment;

export const couponSelector = createSelector(paymentRoot, ({ coupon }) => coupon);
